
import { Fraga } from "@/types/riskbedomning";

export const groundRiskFragor: Fraga[] = [
  {
    id: "mark-ras",
    text: "Finns det risk att någon kan begravas under jordmassor eller sjunka ned i lös mark?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att markförhållandena inte är tillräckligt undersökta och riskbedömda?",
      "Finns det risk att spontning, släntlutning eller annan förstärkning behövs men saknas för att förhindra ras?",
      "Finns det risk att inträngande vatten kan påverka markens stabilitet?",
      "Finns det risk att tunga maskiner i närheten påverkar jordens stabilitet?",
      "Finns det risk att arbetet inte är planerat så att personer vistas onödigt länge i riskområdet?",
      "Finns det risk att riskanalys för närliggande byggnader inte har genomförts?"
    ]
  },
  {
    id: "tranga-utrymmen",
    text: "Finns det risk att projektet innefattar arbete i brunnar, tunnlar eller under jord?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar arbete i riskfyllda utrymmen att ske utan gasmätning, ventilation eller fungerande evakueringsplan?",
      "Finns det risk att tillräcklig ventilation i trånga utrymmen inte kan säkerställas?"
    ]
  }
];
